import { render, staticRenderFns } from "./ArticleEcoTaxForm.vue?vue&type=template&id=6e16a1bc&"
import script from "./ArticleEcoTaxForm.vue?vue&type=script&lang=js&"
export * from "./ArticleEcoTaxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports